
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.024","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1622"}},[_c('path',{attrs:{"data-name":"Rectangle 2349","fill":"none","d":"M0 0h20v20H0z"}}),_c('g',{attrs:{"data-name":"Group 1630","transform":"translate(-809.819 -428.143)"}},[_c('rect',{attrs:{"data-name":"Rectangle 2350","width":"14","height":"20","rx":"1","transform":"translate(812.844 428.143)","fill":"#adadad"}}),_c('rect',{attrs:{"data-name":"Rectangle 2351","width":"3","height":"3","rx":"1","transform":"translate(815.844 431.143)","fill":"#fff"}}),_c('rect',{attrs:{"data-name":"Rectangle 2352","width":"3","height":"3","rx":"1","transform":"translate(820.844 431.143)","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Path 997","d":"M829.551 446.435l-2.567-2.566a5 5 0 10-1.414 1.414l2.567 2.567a1 1 0 001.414-1.415z"}})]),_c('path',{attrs:{"data-name":"Path 998","d":"M13.009 10a2.984 2.984 0 11-2.984 2.984A2.986 2.986 0 0113.009 10","fill":"#fff"}})])])
          )
        }
      }
    